import numeral from 'numeral';
import { Cell } from '@table-library/react-table-library/table';

function createLink(path) {
    const url = new URL(window.location);
    const intent = url.searchParams.get('intent');

    if (intent) path += `&intent=${intent}`;
    return path;
}

export const COLUMNS = (t, project_id, own_domain, keyword) => [
    {
        label: t('commerce.detail.urls.columns.rank'),
        key: 'rank',
        data: 'rank',
        Component: Cell,
        cellSize: 'minmax(40px, 0.5fr)',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong className="wripe">#{data}</strong>;
        },
    },
    {
        label: t('commerce.detail.urls.columns.url'),
        key: 'url',
        data: 'url',
        sortType: 'string',
        cellSize: 'minmax(220px, 2.2fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="d-flex row justify-content-between w-100">
                    <strong className="col-9 wrap-text">
                        <a
                            href={createLink(
                                `/commerce/${project_id}/url/?url=${encodeURIComponent(
                                    data,
                                )}&own_domain=${own_domain}&keyword=${keyword}`,
                            )}
                        >
                            <span>{data}</span> <span style={{ fontSize: '30px' }}>→</span>
                        </a>
                    </strong>
                    <div className="col-2 d-flex align-items-center">
                        <a
                            target="_blank"
                            className="link-website d-inline-flex align-items-center justify-content-center"
                            href={data}
                            rel="noreferrer"
                        >
                            <i className="icon-external-link"></i>
                        </a>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.urls.columns.organicTraffic'),
        key: 'organicTraffic',
        data: 'organicTraffic',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
    {
        label: t('commerce.detail.urls.columns.organicCost'),
        key: 'oganicCost',
        data: 'oganicCost',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
    {
        label: t('commerce.detail.urls.columns.organicKeywords'),
        key: 'organicKeywords',
        data: 'organicKeywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
    {
        label: t('commerce.detail.urls.columns.adTraffic'),
        key: 'trends',
        data: 'trends',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
    {
        label: t('commerce.detail.urls.columns.adKeywords'),
        key: 'adTraffic',
        data: 'adTraffic',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
    {
        label: t('commerce.detail.urls.columns.adCost'),
        key: 'adCost',
        data: 'adCost',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
    {
        label: t('commerce.detail.urls.columns.projectKeywords'),
        key: 'project_keywords',
        data: 'project_keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
    {
        label: t('commerce.detail.urls.columns.projectKeywordsSearchVolume'),
        key: 'project_keywords_search_volume',
        data: 'project_keywords_search_volume',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            ),
    },
];
